module.exports = __webpack_public_path__ + "media/images/KeyMan-873de13e.svg";